export function filesToBase64(fileList) {
  const files = Array.from(fileList);

  const readFileAsBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        resolve({
          name: file.name,
          type: file.type,
          base64: reader.result.split(",")[1], // remove data:*/*;base64, prefix,
        });
      };

      reader.onerror = (error) => {
        reject(error);
      };

      reader.readAsDataURL(file);
    });

  return Promise.all(files.map(readFileAsBase64));
}
